// extracted by mini-css-extract-plugin
export default {"wrapper":"XoneCorner_wrapper__NRPQI","title":"XoneCorner_title__LKH2p","list":"XoneCorner_list__cUkAw"};